import { setTheme } from "theme/default/setTheme";

export const setColor_e74c3c = setTheme(({ theme }) => `color: ${theme.colors.color_e74c3c}`);
